/**
 * The main api service
 */
import http from '@util/http';
import { incubator } from '@api/req';

export async function queryIncuOregistappListByInc(params = {}) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_LISTBYINC, params);
}

export async function queryExportIncuOregistappListByInc(params = {}) {
  return http.download(incubator.INCUBATOR_OREGISTAPP_LISTBYINC_EXPORT, params, '地址清单.xlsx');
}

export async function queryIncuOregistappList(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_LIST, params);
}

export async function queryIncuOregistappMy(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MY, params);
}

export async function queryIncuOregistappMyCheck(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MY_CHECK, params);
}

export async function querySaveIncuOregistapp(params) {
  return http.post(incubator.INCUBATOR_OREGISTAPP_SAVE, params);
}

export async function queryDeleteIncuOregistapp(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_DELETE, params);
}

export async function queryIncuOregistappInfo(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_INFO, params);
}

export async function queryIncuOregistappIsApply(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_ISAPPLY, params);
}

export async function queryNextIncuOregistapp(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_NEXT, params);
}

export async function queryReturnIncuOregistapp(params) {
  return http.post(incubator.INCUBATOR_OREGISTAPP_RETURN, params);
}

export async function queryCallbackIncuOregistapp(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_CALLBACK, params);
}

export async function queryIncuOregistappWorkflow(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_WORKFLOW, params);
}

export async function queryRelateAddress(params) {
  return http.post(incubator.ADDRESS_OREGISTAPP_RELATE, params);
}

export async function queryRenewBusinessInfo(params) {
  return http.get(incubator.RENEW_OREGISTAPP_INFO, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/oregistapp.js